import { render } from "./ErrorComp.vue?vue&type=template&id=3bcba00a"
import script from "./ErrorComp.vue?vue&type=script&lang=js"
export * from "./ErrorComp.vue?vue&type=script&lang=js"
script.render = render

export default script